import React from "react";
import PinnedLottieSection from "../ScrollLottie/PinnedLottieSection";
import { LOTTIE } from "../assets";

export default function MetalCloudWay() {
  return (
    <PinnedLottieSection
      eyebrow="Train Your Factory’s AI based on Your Own Experience"
      heading="True Digitization + AI"
      desktopSrc={LOTTIE.metalcloudWayDesktop}
      mobileSrc={LOTTIE.metalcloudWayMobile}
      ariaLabel="Illustration of MetalCloud turning shopfloor signals into engineered repeatability"
      /* Component 3 sits only 80 below Component 1, plus its own 80 header pad. */
      leadIn="clamp(32px, 8.33vw, 160px)"
    />
  );
}
